import { useQuery, useQueryClient } from 'react-query';
import api from 'services';
import type { ContributionsResponse } from 'services/requests';
import type { ApiError } from 'services/api.errors';
import { CommonCustomError } from 'types/errors';
import { QueryKeys } from 'constants/queryKeys';
import type { AxiosError } from 'axios';
import { useGetAllAssets } from '../portfolio';

export const useGetContributions = () => {
  const queryClient = useQueryClient();
  const { isSuccess, data: allAssets } = useGetAllAssets();

  const queryKey = [QueryKeys.contributionsList];

  const queryFn = async () => {
    if (!allAssets) {
      throw new CommonCustomError();
    }

    const { data } = await api.getContributions();

    const items = data.items.map((dataItem) => {
      const assetInfo = allAssets[dataItem.asset.id];
      if (!assetInfo) {
        throw new CommonCustomError();
      }

      return {
        ...dataItem,
        asset: {
          ...assetInfo,
          amount: dataItem.asset.amount,
          amountStringified: dataItem.asset.amountStringified,
        },
      };
    });

    return {
      items,
    };
  };

  return useQuery<ContributionsResponse, AxiosError<ApiError>>(queryKey, queryFn, {
    initialData() {
      return queryClient.getQueryData<ContributionsResponse>(queryKey);
    },
    enabled: isSuccess,
  });
};
